import { useEffect, useMemo, useRef } from "react";
import { VideoStreamRenderer } from "@azure/communication-calling";
import RenderDynamicView from "../RenderDynamicView";
import "../componentStyle/PinnedParticipantView.css";
import mute_incall from '../new_assets/in_call_mic_off.svg';
import unmute_incall from '../new_assets/in_call_mic_on.svg';

const PinnedParticipantView = ({
    pinnedParticipantId,
    allParticipants,
    localVideoStream,
    isVideoOnGoing,
    isAudioOnGoingLocal,
    localDisplayName,
    getInitials,
    userId,
    participantCount,
    pageIndex,
    isDarkTheme
}) => {

    const localVideoRef = useRef(null);

    // Local PiP video rendering
    useEffect(() => {
        let renderer;

        const renderLocal = async () => {
            if (localVideoRef.current && localVideoStream && isVideoOnGoing) {
                try {
                    renderer = new VideoStreamRenderer(localVideoStream);
                    const view = await renderer.createView();
                    localVideoRef.current.innerHTML = "";
                    localVideoRef.current.appendChild(view.target);
                } catch (e) {
                    console.error("Render local video failed", e);
                }
            }
        };

        renderLocal();
        return () => renderer?.dispose();
    }, [localVideoStream, isVideoOnGoing]);

    const pinnedParticipant = useMemo(
        () => allParticipants.find((p) => p.userId === pinnedParticipantId),
        [allParticipants, pinnedParticipantId]
    );

    const sideParticipants = useMemo(
        () => allParticipants.filter((p) => p.userId !== pinnedParticipantId),
        [allParticipants, pinnedParticipantId]
    );

    const themeName = isDarkTheme ? "dark" : "light";

    return (
        <div className="pinLayout" data-theme={themeName}>

            {/* MAIN LARGE PINNED VIDEO */}
            <div className="pinMain">
                <div className="pinMainVideo">
                    {pinnedParticipant && (
                        <RenderDynamicView
                            key={pinnedParticipantId}
                            item={pinnedParticipant}
                            remoteVideoStream={pinnedParticipant?.stream}
                            isPinned={true}
                            isScreenSharing={false}
                            participantCount={participantCount}
                            pageIndex={pageIndex}
                            variant="pinned-main"
                        />
                    )}
                </div>
            </div>

            {/* RIGHT SIDE SMALL TILES */}
            <div className="pinSidebarBox">
                <div className="pinSidebar">

                    {/* LOCAL USER */}
                    <div className="pinTile pinTile-local">
                            <div className="pinTileContent">
                                {isVideoOnGoing ? (
                                    <div ref={localVideoRef} className="tileVideo"></div>
                                ) : (
                                    <div className="avatarTile">
                                        <span className="avatarInitial">
                                            {getInitials(localDisplayName)}
                                        </span>
                                    </div>
                                )}

                                <img
                                    className="mute-status"
                                    src={isAudioOnGoingLocal ? unmute_incall : mute_incall}
                                    alt={isAudioOnGoingLocal ? "Unmuted" : "Muted"}
                                />
                                <div className="short-name">
                                    {localDisplayName || "You"}
                                </div>
                            </div>
                    </div>

                    {/* REMOTE PARTICIPANTS */}
                    {sideParticipants.map((p, i) => (
                        <div key={p.userId} className="pinTile">
                            <RenderDynamicView
                                item={p}
                                remoteVideoStream={p.stream}
                                isScreenSharing={false}
                                participantCount={participantCount}
                                pageIndex={pageIndex}
                                variant="pinned-side"
                            />
                        </div>
                    ))}

                </div>
            </div>
        </div>
    );
};

export default PinnedParticipantView;
